<template>
   <div
      color="warning"
      class="bottom-warning white--text text-center font-weight-black"
    >
      <h2 class="warning-text">Te encuentras en un ambiente de pruebas, no se guardara ninguna operación realizada aquí.</h2>
    </div>
</template>

<script>

export default {
    name: 'WarningEnvironment'
}
</script>
<style scooped>
  .bottom-warning {
    position: fixed;
    background-color: #F9982F;
    bottom:0px;
    left: 0px;
    height: 35px;
    width: 100%;
  }

  .warning-text {
    display: table;
    margin: auto;
  }

</style>
